const gerar_arquivo_texto_de_docentes_sem_codigo_inep = [
  {
    path: "/gerar-arquivo-texto-de-docentes-sem-codigo-inep",
    name: "gerar_arquivo_texto_de_docentes_sem_codigo_inep",
    meta: {
      breadCrumb: "Censo Escolar - Código Inep",
      allowedPermissions: ["inep_gerar_arquivo_txt_docente"],
    },
    component: () =>
      import(
        "@/views/GerarArquivoTextoDeDocentesSemCodigoInep/GerarArquivoTextoDeDocentesSemCodigoInep.vue"
      ),
  },
];

export { gerar_arquivo_texto_de_docentes_sem_codigo_inep };
